<template>
    <router-link :to="resolvedTo">
        <slot></slot>
    </router-link>
</template>

<script>
import Kernel from "@oilstone/kernel";

const resourceRegistry = Kernel.resolve('resourceRegistry');

export default {
    props: {
        to: {
            required: true,
        }
    },

    computed: {
        resolvedTo() {
            let to = this.to;

            if (typeof to === 'object' && to.type && to.resource) {
                const config = resourceRegistry.find(to.type).config;

                if (to.type === 'collections') {
                    let subtype = '';

                    switch (to.resource.section) {
                        case 'blog-posts':
                            subtype = 'blog-series';
                            break;

                        case 'podcasts':
                            subtype = 'podcast-series';
                            break;
                    }

                    to = `/library/${subtype}/${to.resource.slug}`;
                } else {
                    to = `${config.adminSection}/${config.type}/${to.resource.slug}`;
                }
            }

            return to;
        }
    }
}
</script>
